import { GetFilterType, enumFilterTypes } from "./ImportFilterModal";
import { ImportFilterExclusiveInput } from "./ImportFilterExclusiveInput";
import { ImportFilterLimitFieldsInput } from "./ImportFilterLimitFieldsInput";
import { ImportFilterSeedInput } from "./ImportFilterSeedInput";

export const ImportFilterInput = props => {
  const filterType = GetFilterType(props.importFilter);

  if (filterType === enumFilterTypes.limitfields) {
    return <ImportFilterLimitFieldsInput {...props} />;
  }

  if (filterType === enumFilterTypes.seed) {
    return <ImportFilterSeedInput {...props} />;
  }

  return <ImportFilterExclusiveInput {...props} />;
};
